import React from 'react';
const IconFileAddFill = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14 8V2H4V22H20V8H14ZM16 15H13V18H11V15H8V13H11V10H13V13H16V15Z" fill="#2D2E2E"/>
<path d="M15.5 2.09003V6.50003H19.91L15.5 2.09003Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconFileAddFill;